import { render } from "./StackedBarchart.vue?vue&type=template&id=1ae82414&scoped=true"
import script from "./StackedBarchart.vue?vue&type=script&lang=js"
export * from "./StackedBarchart.vue?vue&type=script&lang=js"

import "./StackedBarchart.vue?vue&type=style&index=0&id=1ae82414&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae82414"]])

export default __exports__